import jsPDF from 'jspdf';
import Logo from "../images/school_logo.png";
import { SCHOOL_ADDRESS, SCHOOL_NAME, SCHOOL_PHONE } from '../Variables.js';

const generateReceiptPDF = (payment, cashierFirstName, cashierLastName) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [80, 297]
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 5;
  const contentWidth = pageWidth - (2 * margin);
  let yPos = margin;

  // Add centered logo at the very top
  try {
    const logoWidth = 15;
    const logoHeight = 15;
    const logoX = (pageWidth - logoWidth) / 2;
    doc.addImage(Logo, 'PNG', logoX, yPos, logoWidth, logoHeight);
    yPos += logoHeight + 2;
  } catch (err) {
    console.log("Logo not found, continuing without it");
  }

  // School name (centered below logo)
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  const wrappedSchoolName = doc.splitTextToSize(SCHOOL_NAME.toUpperCase(), contentWidth);
  wrappedSchoolName.forEach((line) => {
    yPos += 2;
    doc.text(line, pageWidth / 2, yPos, { align: 'center' });
    yPos += 4;
  });

  // School details
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);

  const wrappedAddress = doc.splitTextToSize(SCHOOL_ADDRESS, contentWidth);
  wrappedAddress.forEach((line) => {
    doc.text(line, pageWidth / 2, yPos, { align: 'center' });
    yPos += 4;
  });

  doc.text(`Tel: ${SCHOOL_PHONE}`, pageWidth / 2, yPos, { align: 'center' });
  yPos += 6;

  // Payment Receipt header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('PAYMENT RECEIPT', pageWidth / 2, yPos, { align: 'center' });
  yPos += 2;

  // Divider line
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 5;

  // Payment details
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const cashierName = `${cashierFirstName} ${cashierLastName}`.trim() || 'Unknown';
  const paymentForText = (payment.paymentFor || ['School fees']).join(', ');

  // Payment Method with fallback
  const paymentMethod = payment.paymentMethod || 'Transfer';

  const details = [
    `Date: ${new Date().toLocaleString()}`,
    `Receipt No: ${Math.floor(Math.random() * 1000000).toString().padStart(6, '0')}`,
    `Cashier: ${cashierName}`,
    `Student: ${payment.studentName}`,
    `Class: ${payment.className}`,
    `Term/Session: ${payment.term} Term - ${payment.session}`,
    `Payer: ${payment.payerName}`,
    `Payment For: ${paymentForText}`,
    `Payment Method: ${paymentMethod}`,  // NEW LINE ADDED
    `Amount Paid: N ${payment.amountPaid.toLocaleString()}`,
    `Balance: N ${payment.balance.toLocaleString()}`,
    `Payment Date: ${new Date(payment.timestamp.toDate()).toLocaleString()}`
  ];

  details.forEach(text => {
    const wrappedText = doc.splitTextToSize(text, contentWidth);
    wrappedText.forEach(line => {
      doc.text(line, margin, yPos);
      yPos += 5;
    });
  });

  // Total section
  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 5;

  doc.setFont('helvetica', 'bold');
  doc.text('TOTAL:', margin, yPos);
  doc.text(`N ${payment.amountPaid.toLocaleString()}`, margin + 42, yPos);
  yPos += 10;

  // Footer
  doc.setFont('helvetica', 'italic');
  doc.text('Thank you for your payment!', pageWidth / 2, yPos, { align: 'center' });
  yPos += 5;

  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated on ${new Date().toLocaleString()}`, pageWidth / 2, yPos, { align: 'center' });
  yPos += 5;

  // Adjust page height if content is too long
  const contentHeight = yPos + 10;
  if (contentHeight > 297) {
    doc.internal.pageSize.height = contentHeight;
  }

  doc.save(`Payment_Receipt_${payment.studentName}_${new Date().toLocaleString().replace(/[/:, ]/g, '_')}.pdf`);
};

export default generateReceiptPDF;